<template>
  <div class="d-flex justify-end align-center h5"
       style="padding: 26px 20px;"
       v-if="meta != null"
  >
    <!-- item per page -->
    <div class="mr-10px d-flex align-center">
      <span class="mr-10px">單頁顯示筆數</span>
      <TableNumPerPage
        v-model="meta.per_page"
        @handleChangeEvent="handleNextPreEvent"
      ></TableNumPerPage>
    </div>
    <!-- item total -->
    <div class="mr-10px">
      <span style="margin-right: 2px">{{ `${meta.from || 0}-${meta.to || 0}` }}</span>
      <span>共 {{ meta.total }}筆</span>
    </div>
    <!-- pre and next -->
    <div>
      <button class="btn square w-32px h-32px mr-4" @click="prevPage">
        <v-icon>navigate_before</v-icon>
      </button>
      <button class="btn square w-32px h-32px" @click="nextPage">
        <v-icon>navigate_next</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import TableNumPerPage from '@/components/TableNumPerPage.vue';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: String,
      default: '',
    },
  },
  components: {
    TableNumPerPage,
  },
  computed: {
    meta: {
      get() {
        return this.$store.state[this.model].meta;
      },
      set(newValue) {
        this.$store.state[this.model].meta = newValue;
      },
    },
  },
  methods: {
    handleNextPreEvent() {
      this.$emit('handleNextPreEvent');
    },
    prevPage() {
      if (this.meta.current_page === 1) {
        return;
      }
      this.meta.current_page -= 1;
      this.$emit('handleNextPreEvent');
    },
    nextPage() {
      if (this.meta.last_page === this.meta.current_page) {
        return;
      }
      this.meta.current_page += 1;
      this.$emit('handleNextPreEvent');
    },
  },
};
</script>

<style></style>
